import { useSearchParams } from "react-router-dom";
import { useQuery, useQueryClient, useMutation} from "@tanstack/react-query";
import { useForm } from "react-hook-form";
import { get, post } from "@utils/axios_api";
import { qk } from "@utils/queryKey";

const fetchLectureApplyList = async (params) => {
  const response = await get("/admin/lectureApply/applyList", { params });
  return response;
};


export function useLectureApply(lectureId) {
  const [searchParams, setSearchParams] = useSearchParams();
  const queryClient = useQueryClient();
  
  const methods = useForm({
    defaultValues: {
      searchCnd: "",
      searchWrd: "",
    },
    shouldFocusError: false, // Focus 방지(포커스 구현시 React ref 구현 해야함)
  });
  
  const searchCnd = searchParams.get("searchCnd") || "";
  const searchWrd = searchParams.get("searchWrd") || "";
  const pageIndex = parseInt(searchParams.get("pageIndex") || "1", 10);
  const recordCountPerPage = 10;

  const queryParam = {
    searchCnd, searchWrd, lectureId,
    pageIndex, recordCountPerPage,
  };

  const { data, refetch } = useQuery({
    queryKey: [...qk.applyList(lectureId), JSON.stringify(queryParam)],
    queryFn: () => fetchLectureApplyList(queryParam),
    keepPreviousData: true,
    enabled: !!lectureId
  });

  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: qk.lectureUser(lectureId) });
    queryClient.invalidateQueries({ queryKey: qk.lectureAdminRoot(lectureId) });
    queryClient.invalidateQueries(["selectHistoryModalList", lectureId]);
  };


  const refreshList = () => {
    refetch();
  };

  const onSubmit = (values) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("searchCnd", values.searchCnd || "");
    newParams.set("searchWrd", values.searchWrd || "");
    newParams.set("pageIndex", "1");
    setSearchParams(newParams);
  };

  const handlePageChange = (targetPage) => {
    const newParams = new URLSearchParams(searchParams);
    newParams.set("pageIndex", targetPage);
    setSearchParams(newParams);
  };
  const resetSearch = () => {
    if (!window.confirm('조회 조건을 초기화 하시겠습니까?')) return;
    methods.reset({
      searchCnd: "",
      searchWrd: "",
    });
    setSearchParams(new URLSearchParams());
  };

  const approveMut = useMutation(
    ({ memberId, lastDt, payType }) =>
      post('/admin/lectureApply/approve', { lectureId, memberId, lastDt, payType }),
    {
      onSuccess: (res) => {
        alert(res.message || '승인되었습니다.');
        invalidate();
              // 전체 세금 계산서 쿼리 초기화 필요
    // queryClient.invalidateQueries(["", ]);
      },
      onError: (err) => alert(err.message || '승인 중 오류가 발생했습니다.'),
    },
  );

  const cancelMut = useMutation(
    ({ memberId, payType }) =>
      post('/admin/lectureApply/cancel', { lectureId, memberId, payType }),
    {
      onSuccess: (res) => {
        alert(res.message || '승인 취소되었습니다.');
        invalidate();
              // 전체 세금 계산서 쿼리 초기화 필요
    // queryClient.invalidateQueries(["", ]);
      },
      onError: (err) => alert(err.message || '취소 중 오류가 발생했습니다.'),
    },
  );

  const rejectMut = useMutation(
    ({ memberId }) =>
      post('/admin/lectureApply/reject', {lectureId, memberId }),
    {
      onSuccess: (res) => {
        alert(res.message || '반려되었습니다.');
        invalidate();
      },
      onError: (err) => alert(err.message || '반려 중 오류가 발생했습니다.'),
    },
  );

  const handleApprove = (row, data) => {
    if (data.curStudentCnt >= data.eduStdntLimit) {
      alert("정원이 가득 찼습니다. 더 이상 승인할 수 없습니다.");
      return;
    }

    if (!window.confirm('승인 하시겠습니까?')) return;
    approveMut.mutate({ memberId: row.memberId, lastDt:data.lastDt, payType:row.payType });
  }

  const handleCancel = (row) => {
    if (!window.confirm('승인 취소 하시겠습니까?')) return;
    cancelMut.mutate({ memberId: row.memberId, payType: row.payType });
  };

  const handleReject = (row) => {
    if (!window.confirm('반려 하시겠습니까?')) return;
    rejectMut.mutate({ memberId: row.memberId });
  };


  return {
    methods, data,
    onSubmit,
    handlePageChange, handleApprove, handleCancel, handleReject, resetSearch,
    pageIndex, recordCountPerPage,
    refetch, refreshList,
  };
}
